import {RotationOrientationType} from "@Features/icons/types/RotationOrientationType";
import {RotationAxisType} from "@Features/icons/types/RotationAxis.type";

export default function setOrientation(startingOrientation: RotationOrientationType, orientation: RotationOrientationType, axis: RotationAxisType = "") {
    const orientations: RotationOrientationType[] = ["up", "right", "down", "left"]
    const orientationsCount = orientations.length

    const startingOrientationIndex = orientations.indexOf(startingOrientation)
    const nextOrientationIndex = startingOrientationIndex === orientationsCount - 1 ? 0 : startingOrientationIndex + 1
    const previousOrientationIndex = startingOrientationIndex === 0 ? orientationsCount - 1 : startingOrientationIndex - 1

    const pairedOrientations = [
        orientations[startingOrientationIndex],
        orientations[nextOrientationIndex],
        orientations[previousOrientationIndex],
    ]

    const counterAnimation = orientations.filter((or) => (
        !pairedOrientations.includes(or)
    ))[0]

    const rotate = {
        [startingOrientation]: "0deg",
        [orientations[nextOrientationIndex]]: "90deg",
        [orientations[previousOrientationIndex]]: "-90deg",
        [counterAnimation]: "180deg",
    }

    return rotate[orientation] ? {transform: `rotate${axis}(${rotate[orientation]})`} : {};
}